import React, { useContext } from "react";
import { Route, Redirect } from "react-router-dom";
import { ApiContext } from '../context/ApiContext'
import { useCookies } from 'react-cookie';
import { connect } from 'react-redux';

const Secured = ({ user, component: Component, ...rest }) => {
    const [cookies] = useCookies(['isLoggedinASC', 'AscID']);

    return (
        <Route
            {...rest}
            render={(props) => {
                if (user.level === 2 || cookies.isLoggedinASC) {
                    return <Component {...props} />;
                } else {
                    return (
                        <Redirect
                            to='/'
                        />
                    );
                }
            }}
        />
    );
};

const mapStateToProps = state => {
    return state;
}

export default connect(mapStateToProps)(Secured)
